import reduxFetch from 'react-redux-fetch';
import apiRoutes from '../../../../app/api/routes';
import { PRINCIPALS_RESOURCE, CREATE_PRINCIPAL_RESOURCE } from '../../constants';
import { createErrorMessage } from '../../../app/helpers/createErrorMessage';

const CreatePrincipalService = ComposedComponent =>
  reduxFetch([
    {
      resource: CREATE_PRINCIPAL_RESOURCE,
      method: 'post',
      request: (body, callback, t) => ({
        url: apiRoutes.principals(),
        body,
        meta: {
          callback,
          addToOtherList: {
            resource: `${PRINCIPALS_RESOURCE}_${body.organisation.id}`,
          },
          toaster: {
            onErrorMessage: createErrorMessage(t, 'createPrincipalFailed'),
            onSuccessMessage: t('createPrincipalSuccess'),
          },
        },
      }),
    },
  ])(ComposedComponent);

export default CreatePrincipalService;
